import { Component, HostBinding, input } from '@angular/core';

import { CalendarEvent } from '../../calendar.types';

@Component({
  selector: 'lepi-calendar-repeat-icon',
  template: `
    @if (event(); as event) {
      <span
        [attr.data-all-day]="event.allDay"
        class="icon icon-[mdi--history] !size-5"></span>
    }
  `,
  styleUrls: ['./repeat-icon.component.css'],
  imports: [],
})
export class CalendarRepeatIcon {
  @HostBinding('class') class = 'flex h-full items-center';
  event = input.required<CalendarEvent>();
}
